import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, className, y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHead({ eyebrow, title, sub, align = "left" }) {
  const alignCls = align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <Reveal className={`flex flex-col gap-4 ${alignCls}`}>
      <span className="font-mono text-xs uppercase tracking-[0.25em] font-semibold text-blue-400">
        {eyebrow}
      </span>
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-zinc-100 max-w-2xl">
        {title}
      </h2>
      {sub ? <p className="text-base text-zinc-400 leading-relaxed max-w-xl">{sub}</p> : null}
    </Reveal>
  );
}
